import { Category, CategoryService, SortOrder } from '../../../services/category-service';

export const getSettingsCategory = async ({
  categoryService,
  targetCategoryId,
}: {
  categoryService: CategoryService;
  targetCategoryId?: string;
}): Promise<Category | undefined> => {
  try {
    let category: Category | undefined;

    if (targetCategoryId) {
      category = await categoryService.getCategory(targetCategoryId);
    } else {
      const categories = await categoryService.queryCategories({
        sort: [{ fieldName: 'createdDate', order: SortOrder.ASC }],
      });

      category =
        categories.filter((category) => category.id === targetCategoryId)[0] ?? categories[0];
    }

    return category;
  } catch (e) {
    throw e instanceof Error ? e : new Error('Failed to get settings category');
  }
};
